export default __webpack_public_path__ + "static/media/uw3.8d9b0dfc.png";